import type {
  FastTrackGraduationResponse,
  FastTrackGraduationResponseRaw,
} from 'views/FastTrackContentView/types';

export function parseFastTrackGraduation(
  raw: FastTrackGraduationResponseRaw,
): FastTrackGraduationResponse {
  if (raw.status === 'success') {
    return {
      status: raw.status,
      email: raw.email,
      appId: raw.app_id,
      grade: raw.grade,
      passingGrades: raw.passing_grades,
      chaptersTotal: raw.chapters_total,
      chaptersUpdated: raw.chapters_updated,
      trainingStarted: raw.training_started,
      trainingGraduated: raw.training_graduated,
      chapterResults: raw.chapter_results,
      message: raw.message,
    };
  }

  return {
    status: raw.status,
    email: raw.email,
    appId: raw.app_id,
    grade: raw.grade,
    passingGrades: raw.passing_grades,
    message: raw.message,
  };
}
